// extracted by mini-css-extract-plugin
export default {"box":"styles_box__m19mw","size":"styles_size__ZjS4U","pre_box":"styles_pre_box__dCkHi","preBreath":"styles_preBreath__kp8aP","breath":"styles_breath__lIPl6"};